import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getMonthTHFromInt,getMainCookie,checkStatus } from '../../../../util/util';
import { withNamespaces } from 'react-i18next';

var user_id = "";
var user_name = "";
var token = "";
class News extends Component {

    constructor(props) {


        super(props);
        this.state  = {
            newsList:[]
        };

        //this.btnDelClose = React.createRef();
        console.log('NewsViewer');
    }
    componentDidMount(){
        let main = getMainCookie();
        user_id = main.user_id;
        user_name = main.login_name;
        token = main.token;
        this.getNews();
    }
    componentWillUnmount(){
        this.setState({
            newsList: []
        })

    }
    getNews(){
        console.log('getNews...');
        let currentComponent = this;
        fetch(this.props.url, {
            method: 'post',
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('Created Gist:', data);
            if(data.RESULT_DATA){
                currentComponent.setState({
                    newsList: data.RESULT_DATA
                })

            }

        });
    }

    convertDate(date){
        let d = date.split('-');
        return  d[2].substring(0,2)+' ' + getMonthTHFromInt(parseInt(d[1])) + ' ' +  (parseInt(d[0])+543);
    }
    newNews(){
        this.refs.dvNewAlert.innerHTML="";
        this.refs.txtNewTitle.value="";
        this.refs.txtNewDetail.value="";
    }
    editeNews(news){
        console.log(news);
        this.refs.dvEditAlert.innerHTML="";
        this.refs.txtEditTitle.value=news.title;
        this.refs.txtEditDetail.value=news.details;
        this.refs.txtNewsID.value=news._id;
    }
    deleteNews(news){
        console.log(news);
        this.refs.txtDelTitle.innerHTML=news.title;
        this.refs.txtNewsID.value=news._id;
    }
    callNewNews(){
        this.refs.dvNewAlert.innerHTML="";
        if(this.refs.txtNewTitle.value.trim() === "" && this.refs.txtNewDetail.value.trim()===""){
            this.refs.dvNewAlert.innerHTML="กรุณาใส่ข้อความ";
            return;
        }
        let currentComponent = this;
        fetch(this.props.url.replace("getNewsList","newNews"), {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify(
                {
                    "title":this.refs.txtNewTitle.value,
                    "details":this.refs.txtNewDetail.value
                }
            )
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('newNews', data);
            currentComponent.btnNewClose.click();
            currentComponent.getNews();

        });
    }
    callEditNews(){
        this.refs.dvEditAlert.innerHTML="";
        if(this.refs.txtEditTitle.value.trim() === "" && this.refs.txtEditDetail.value.trim()===""){
            this.refs.dvEditAlert.innerHTML="กรุณาใส่ข้อความ";
            return;
        }
        let currentComponent = this;
        fetch(this.props.url.replace("getNewsList","newNews"), {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify(
                {
                    "title":this.refs.txtEditTitle.value,
                    "details":this.refs.txtEditDetail.value
                }
            )
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('deleteNews', data);
            currentComponent.callDeleteNews();
            currentComponent.btnEditClose.click();
            currentComponent.getNews();

        });
    }
    callDeleteNews(){
        let currentComponent = this;
        fetch(this.props.url.replace("getNewsList","deleteNews/")+ this.refs.txtNewsID.value , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",

                // "user_id":user_id,
                // "user_name":user_name,
                "token":token
                },
            body: JSON.stringify({})
        }).then(function(response) {
            return checkStatus(response);
        }).then(function(data) {
            console.log('deleteNews', data);
            currentComponent.btnDelClose.click();
            currentComponent.getNews();

        });
    }

    render(){
        const { t } = this.props;
        const {newsList}=this.state;
        let rows = [];

        newsList.map(news=>{
            console.log("details",news.details);
            rows.push(
                <tr>
                <td style={{wordBreak:'break-word'}}>{news.title}</td>
                <td style={{wordBreak:'break-word'}}>{news.details}</td>
                <td>{this.convertDate(news.last_upd_dtm)}</td>
                <td>{news.last_upd_user}</td>
                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button onClick={this.editeNews.bind(this, news)} className="btn btn-info btn-xs" data-title="Edit" data-toggle="modal" data-target="#newsEdit"><span className="fa fa-pencil" /></button></p></td>
                <td ><p data-placement="top" data-toggle="tooltip" title="Delete">
                    <button onClick={this.deleteNews.bind(this,news)} className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal" data-target="#newsDelete"><span className="fa fa-trash" /></button></p></td>
                </tr>
            )

        });




        return(<div className="gray-panel">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="page-header"> <i className="fa fa-newspaper-o" style={{color: '#7386D5'}} />&nbsp;{t('ข่าว')}</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 table-responsive">
                            <table  className="table table-bordred table-striped table-hover ">
                                <thead style={{textAlign:'center'}}>
                                    <tr>
                                    <th>{t('เรื่อง')}</th>
                                    <th>{t('รายละเอียด')}</th>
                                    <th>{t('วันที่')}</th>
                                    <th>admin</th>
                                    <th style={{textAlign:'right'}}>
                                    <button onClick={this.newNews.bind(this)}  className="btn btn-primary btn-xs" data-title="Add" data-toggle="modal" data-target="#newNews"><span className="fa fa-plus" /></button>
                                    </th>
                                    <th></th>
                                    </tr></thead>
                                <tbody>
                                    {rows}
                                </tbody>
                            </table>
                        </div>
                    </div>



                        <div className="modal fade" id="newNews" tabIndex={-1} role="dialog" aria-labelledby="newNews" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading">{t('เพิ่มข่าว')}</h4>
                                <button ref={input => this.btnNewClose = input} type="button" className="close"  style={{padding:0,margin:0}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                <h6>{t('หัวข้อ')}</h6>
                                <input className="form-control required" type="text" placeholder="" ref="txtNewTitle"/>
                                </div>
                                <h6>{t('รายละเอียด')}</h6>
                                <div className="form-group">
                                <textarea rows={4} className="form-control required" placeholder="" defaultValue={""} ref="txtNewDetail"/>
                                </div>
                                <div ref="dvNewAlert" className='textAlert'></div>
                            </div>

                            <div className="modal-footer ">

                                <button type="button" className="btn btn-primary btn-lg" style={{width: '100%'}} onClick={this.callNewNews.bind(this)} ><span className="fa fa-check" />&nbsp;{t('เพิ่มข่าว')}</button>
                            </div>
                            </div>
                            {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                        </div>

                        <div className="modal fade" id="newsEdit" tabIndex={-1} role="dialog" aria-labelledby="newsEdit" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading">{t('แก้ไขข่าว')}</h4>
                                <button ref={input => this.btnEditClose = input} type="button" className="close"  style={{padding:0,margin:0}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                <h6>{t('หัวข้อ')}</h6>
                                <input className="form-control " type="text" placeholder="" ref="txtEditTitle"/>
                                </div>
                                <div className="form-group">
                                <h6>{t('รายละเอียด')}</h6>
                                <textarea rows={4} className="form-control" placeholder="" defaultValue={""} ref="txtEditDetail"/>
                                </div>
                                <div ref="dvEditAlert" className='textAlert'></div>
                            </div>
                            <div className="modal-footer ">
                                <button type="button" className="btn btn-primary btn-lg" style={{width: '100%'}} onClick={this.callEditNews.bind(this)} ><span className="fa fa-check" />&nbsp;{t('แก้ไข')}</button>
                            </div>
                            </div>
                            {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                        </div>
                        <div className="modal fade " id="newsDelete" tabIndex={-1} role="dialog" aria-labelledby="edit" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading">{t('ลบข่าว')}</h4>
                                <button type="button" className="close" style={{padding:0,margin:0}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-danger"><span className="fa fa-warning" />{t('คุณต้องการลบ')} &nbsp;
                                <span style={{fontWeight:'bold'}} ref="txtDelTitle"></span>

                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button type="button" className="btn btn-primary" onClick={this.callDeleteNews.bind(this)}><span className="fa fa-check" />&nbsp;{t('ตกลง')}</button>
                                <button ref={input => this.btnDelClose = input}  type="button" className="btn btn-danger" data-dismiss="modal"><span className="fa fa-times" />&nbsp;{t('ยกเลิก')}</button>
                            </div>
                            </div>
                            {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                        </div>

                    <input type="hidden" ref="txtNewsID" />
                </div>

        );
    }
}
News.propTypes = {
    t: PropTypes.func.isRequired,
    url: PropTypes.string,

};
News.defaultProps = {
    url: 'http://203.150.199.244/api/admin/getNewsList'
};
export default withNamespaces('Menubar')(News);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/News.js